import { Vue, Component, Prop } from 'vue-property-decorator';
import { MessageModel } from '../../types';

@Component
export default class GuardianMessagesComponent extends Vue {
    @Prop() messages!: MessageModel[];
}
